import { FaHome, FaSyringe } from "react-icons/fa";
import { BiBuildings, BiCategory } from "react-icons/bi";
import { ImTree } from "react-icons/im";
import { AiFillControl } from "react-icons/ai";
import { BsBag } from "react-icons/bs";
import { TbChartDots3, TbTransformFilled } from "react-icons/tb";
import { RiAdminFill } from "react-icons/ri";

// Data for the sidebar navigation
export const SIDEBAR_DATA = [
  {
    name: "/dep/dashboard", // URL path for the dashboard
    title: "Dashboard", // Display title
    icon: <FaHome />, // Icon component from react-icons
    level: 0, // Navigation level
    admin: false, // Accessibility for admin users
    index: 1, // Index for ordering
  },
  {
    name: "/dep/domain", // URL path for the domain
    title: "Function", // Display title
    icon: <BiCategory />, // Icon component from react-icons
    level: 0, // Navigation level
    admin: false, // Accessibility for admin users
    index: 2, // Index for ordering
  },
  {
    name: "/dep/client/all-clients", // URL path for all clients
    title: "Sub-Function", // Display title
    icon: <BiBuildings />, // Icon component from react-icons
    level: 0, // Navigation level
    admin: false, // Accessibility for admin users
    index: 3, // Index for ordering
  },
  {
    name: "/dep/instrument", // URL path for instrument
    title: "Data source", // Display title
    icon: <AiFillControl />, // Icon component from react-icons
    level: 0, // Navigation level
    admin: false, // Accessibility for admin users
    index: 4, // Index for ordering
  },
  {
    name: "/dep/engagement/all-engagements", // URL path for all engagements
    title: "Pipeline Name", // Display title
    icon: <ImTree />, // Icon component from react-icons
    level: 0, // Navigation level
    admin: false, // Accessibility for admin users
    index: 5, // Index for ordering
  },
  {
    name: "/dep/workflow/all-workflows", // URL path for all workflows
    title: "Workflows", // Display title
    icon: <TbChartDots3 />, // Icon component from react-icons
    level: 1, // Navigation level
    admin: false, // Accessibility for admin users
    index: 6, // Index for ordering
    innerSidebars: [
      // Sub-navigation items
      {
        name: "/data-all", // URL path for all data workflows
        title: "ALL Workflows", // Display title
        icon: <BsBag />, // Icon component from react-icons
        level: 0, // Navigation level
        innerIndex: 6.1, // Index for ordering within parent
      },
      {
        name: "/data-ingestion", // URL path for data ingestion workflows
        title: "Data Ingestion", // Display title
        icon: <FaSyringe />, // Icon component from react-icons
        level: 0, // Navigation level
        innerIndex: 6.2, // Index for ordering within parent
      },
      {
        name: "/data-transformation", // URL path for data transformation workflows
        title: "Data Transformations", // Display title
        icon: <TbTransformFilled />, // Icon component from react-icons
        level: 0, // Navigation level
        innerIndex: 6.3, // Index for ordering within parent
      },
    ],
  },
  {
    name: "/dep/admin", // URL path for admin
    title: "Admin", // Display title
    icon: <RiAdminFill />, // Icon component from react-icons
    level: 0, // Navigation level
    admin: true, // Accessibility for admin users only
    index: 7, // Index for ordering
  },
];
